import { render } from "./ConnectionLastSeen.vue?vue&type=template&id=23dd30d2&scoped=true"
import script from "./ConnectionLastSeen.vue?vue&type=script&lang=js"
export * from "./ConnectionLastSeen.vue?vue&type=script&lang=js"

import "./ConnectionLastSeen.vue?vue&type=style&index=0&id=23dd30d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23dd30d2"

export default script